import styled from "styled-components"

import Button from "components/presenters/button/Button"

export default function ChallengeStartButton({ onChallengeStartClick, toolTip }) {
  return (
    <ButtonBlock>
      <StartButton onClick={onChallengeStartClick} fullwidth>{'인증 시작하기'}</StartButton>
      {toolTip}
    </ButtonBlock>
  )
}

const ButtonBlock = styled.div`
  position: relative;
  width: 100%;
`;

const StartButton = styled(Button)`
  font-size: calc(100vw * (14 / 375));
  font-weight: 700;
  line-height: calc(100vw * (20.27 / 375));
  background-color: #FFCF19;
  border-radius: calc(100vw * (5 / 375));
  padding: calc(100vw * (16 / 375)) 0;
`;
